export enum EThunkRejectCause {
  /* В результате операции получили пустой результат */
  EmptyResult = 'emptyResult',
  /* Ошибка при выполнении операции */
  Error = 'error',
  /* Результат выполнения операции не актуален из-за выполнения конкурентной операции */
  Concurrency = 'concurrency',
  /* Выполнение операции прервано */
  Aborted = 'aborted',
}
